import Cookies from "js-cookie";
import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import ResetPasswordHook from "../../hook/auth/ResetPasswordHook";

const ResetPasswordPage = () => {
  const [
    webSiteData,
    settingsRes,
    newPassword,
    confirmPassword,
    value,
    onChangeNewPassword,
    onChangeConfirmPassword,
    changePassword
  ] = ResetPasswordHook();
  const primaryColor = settingsRes?.data?.cartColor || settingsRes?.data?.primaryColor || "#3182ce";
  const { t } = useTranslation();

  return (
    <div className="cart-page-bg font" style={{ minHeight: "100vh", display: "flex", alignItems: "center" }}>
      <Helmet>
        <title>
          {`${t("إعادة تعيين كلمة المرور")}- ${
            Cookies.get("i18next") == "ar"
              ? settingsRes?.data?.titleAr
              : settingsRes?.data?.titleEn
          }`}{" "}
        </title>
      </Helmet>

      <Container>
        <Row className="justify-content-center">
          <Col lg="5" md="7" sm="10" xs="12">
            <div className="checkout-section-card" style={{ padding: "40px 32px" }}>
              
              {/* Header */}
              <div className="text-center mb-4">
                <div className="d-inline-flex align-items-center justify-content-center mb-3" style={{ width: 60, height: 60, borderRadius: '50%', backgroundColor: `${primaryColor}15` }}>
                  <i className="fa-solid fa-unlock-keyhole" style={{ fontSize: '1.5rem', color: primaryColor }}></i>
                </div>
                <h4 className="fw-bold text-dark mb-1">{t("إعادة تعيين كلمة المرور")}</h4>
              </div>

              {/* Form */}
              <div className="mb-3">
                <label className="form-label text-muted fw-bold small">{t("البريد الإلكتروني أو رقم الجوال")}</label>
                <div className="position-relative">
                  <i className="fa-solid fa-user position-absolute text-muted" style={{ top: '50%', right: '14px', transform: 'translateY(-50%)', fontSize: '0.85rem' }}></i>
                  <input
                    value={value}
                    disabled={true}
                    type="text"
                    className="form-control bg-light border-0 py-3 font text-muted"
                    style={{ paddingRight: '40px', cursor: 'not-allowed' }}
                  />
                </div>
              </div>

              <div className="mb-3">
                <label className="form-label text-muted fw-bold small">{t("new password")}</label>
                <div className="position-relative">
                  <i className="fa-solid fa-lock position-absolute text-muted" style={{ top: '50%', right: '14px', transform: 'translateY(-50%)', fontSize: '0.85rem' }}></i>
                  <input
                    value={newPassword}
                    onChange={onChangeNewPassword}
                    placeholder={t("enter new password")}
                    type="password"
                    className="form-control bg-light border-0 py-3 font"
                    style={{ paddingRight: '40px' }}
                  />
                </div>
              </div>

              <div className="mb-4">
                <label className="form-label text-muted fw-bold small">{t("confirm password")}</label>
                <div className="position-relative">
                  <i className="fa-solid fa-lock position-absolute text-muted" style={{ top: '50%', right: '14px', transform: 'translateY(-50%)', fontSize: '0.85rem' }}></i>
                  <input
                    value={confirmPassword}
                    onChange={onChangeConfirmPassword}
                    placeholder={t("confirm new password")}
                    type="password"
                    className="form-control bg-light border-0 py-3 font"
                    style={{ paddingRight: '40px' }}
                  />
                </div>
              </div>

              {/* Submit */}
              <button
                onClick={changePassword}
                className="btn w-100 text-white fw-bold py-3 border-0 font"
                style={{ backgroundColor: primaryColor, borderRadius: '10px', fontSize: '1.05rem' }}
              >
                {t("save")}
              </button>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ResetPasswordPage;
